import React from 'react'
import TextInput from '../../social-stack-web/src/components/TextInput';
import styles from '../../social-stack-web/src/components/registration/Registration.module.css'

export const InfoForm = ({data}) => {
    
    const { 
        industry_error, 
        OnchangeIndustry,
    } = data;
return  <div className={styles.contentContainer}>
<div>
    <TextInput
        label={'TEAM, ROLE OR TITLE'}
        type={''}
        error={industry_error}
        onValueChange={(text) => 
            OnchangeIndustry(text.target.value)
            
    }
    />
    <p>
        e.g Analyst, Marketing, Sales, etc
    </p>
</div>



</div>
}